import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { Toaster } from './components/ui/sonner';
import Landing from './pages/Landing';
import VkLanding from './pages/VkLanding';
import VkLandingV2 from './pages/VkLandingV2';
import VkRegisterLanding from './pages/VkRegisterLanding';
import CompleteProfile from './pages/CompleteProfile';
import Filters from './pages/Filters';
import VideoChat from './pages/VideoChat';
import Matches from './pages/Matches';
import Chat from './pages/Chat';
import Profile from './pages/Profile';
import Subscriptions from './pages/Subscriptions';
import AdminDashboard from './pages/AdminDashboard';
import Footer from './components/Footer';
import './App.css';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <p className="text-[#7A7A7A]">Загрузка...</p>
      </div>
    );
  }
  
  return isAuthenticated ? children : <Navigate to="/" replace />;
};

const CompletedProfileRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <p className="text-[#7A7A7A]">Загрузка...</p>
      </div>
    );
  }

  return user?.profile_completed ? children : <Navigate to="/complete-profile" replace />;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/vk" element={<VkLanding />} />
      <Route path="/vk2" element={<VkLandingV2 />} />
      <Route path="/vk-register" element={<VkRegisterLanding />} />
      <Route
        path="/complete-profile"
        element={
          <ProtectedRoute>
            <CompleteProfile />
          </ProtectedRoute>
        }
      />
      <Route
        path="/filters"
        element={
          <ProtectedRoute>
            <CompletedProfileRoute><Filters /></CompletedProfileRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/videochat"
        element={
          <ProtectedRoute>
            <CompletedProfileRoute><VideoChat /></CompletedProfileRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/matches"
        element={
          <ProtectedRoute>
            <CompletedProfileRoute><Matches /></CompletedProfileRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/chat/:matchId"
        element={
          <ProtectedRoute>
            <CompletedProfileRoute><Chat /></CompletedProfileRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <CompletedProfileRoute><Profile /></CompletedProfileRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/subscriptions"
        element={
          <ProtectedRoute>
            <CompletedProfileRoute><Subscriptions /></CompletedProfileRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App min-h-screen flex flex-col">
          <div className="flex-1">
            <AppRoutes />
          </div>
          <Footer />
          <Toaster position="top-center" richColors />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
